<!--
 * @Description: 页码
 * @Date: 2024-01-11 13:52:40
-->
<template>
  <div class="bi-tmpl-detail__right__cmpt">
    <div>
      <span class="bi-tmpl-detail__right__cmpt__title">
        {{ curItem.title }}
      </span>
      <span v-if="curItem.tips" class="bi-tmpl-detail__right__cmpt__tips">
        {{ curItem.tips }}
      </span>
    </div>
    <Carousel ref="carouselRef" :itemHeight="130" :itemWidth="420 + 56">
      <div
        style="height: 130px"
        v-for="(item, index) in group(TYPE_MAPPING, 4)"
        :key="index"
      >
        <BaseCard style="width: 420px; height: 130px">
          <div style="display: flex; width: 385px; height: 130px">
            <BaseRadio
              class="bi-tmpl-detail__right__cmpt__radio bi-tmpl-detail__right__cmpt__radio--w"
              v-for="child in item"
              :key="child.value"
              :value="child.value"
              :model-value="curItem.value"
              @click="onChange(child.value)"
            >
              <component
                style="width: 60px; height: 25px; margin-top: 5px"
                :isDetail="true"
                :is="cmpName(child.value)"
              />
            </BaseRadio>
          </div>
        </BaseCard>
      </div>
    </Carousel>
  </div>
</template>

<script lang="ts" setup>
import PcModulePage from '@V/bi-tmpl/src/components/bi-pc-module/pc-module-page-number';

import { BaseRadio } from 'xrk-components';
import { BaseCard } from 'xrk-components';
import { useDetailCmpt } from '@V/bi-tmpl/src/hooks';
import { Carousel } from '@/components/base/carousel';

const CHILD_KEY = '101_4';
const TYPE_MAPPING = {
  1: {
    value: 'pc-module-page-number-1',
    moduleType: 'pc-module-page-number-1'
  },
  2: {
    value: 'pc-module-page-number-2',
    moduleType: 'pc-module-page-number-2'
  },
  3: {
    value: 'pc-module-page-number-3',
    moduleType: 'pc-module-page-number-3'
  },
  4: {
    value: 'pc-module-page-number-4',
    moduleType: 'pc-module-page-number-4'
  },
  5: {
    value: 'pc-module-page-number-5',
    moduleType: 'pc-module-page-number-5'
  },
  6: {
    value: 'pc-module-page-number-6',
    moduleType: 'pc-module-page-number-6'
  },
  7: {
    value: 'pc-module-page-number-7',
    moduleType: 'pc-module-page-number-7'
  },
  8: {
    value: 'pc-module-page-number-8',
    moduleType: 'pc-module-page-number-8'
  },
  9: {
    value: 'pc-module-page-number-9',
    moduleType: 'pc-module-page-number-9'
  },
  10: {
    value: 'pc-module-page-number-10',
    moduleType: 'pc-module-page-number-10'
  },
  11: {
    value: 'pc-module-page-number-11',
    moduleType: 'pc-module-page-number-11'
  },
  12: {
    value: 'pc-module-page-number-12',
    moduleType: 'pc-module-page-number-12'
  }
};

const cmpName = name => {
  return PcModulePage.filter(comp => comp.__name === name)[0];
};

const { curItem, onChange, group } = useDetailCmpt({ childKey: CHILD_KEY });
</script>
<style scoped lang="scss"></style>
